import { Pipe, PipeTransform } from '@angular/core';
import { IBase } from '@brafton/common-framework-library';
import { ProjectHelper } from 'src/app/core';

@Pipe({
  name: 'findRoute',
})
export class FindRoutePipe implements PipeTransform {
  constructor(private projectHelper: ProjectHelper) {}

  transform(baseDeliverable: IBase | undefined): string | undefined {
    if (!baseDeliverable || baseDeliverable === undefined) return;
    return this.projectHelper.findRoute(baseDeliverable);
  }
}
